import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { UtilsModule } from '../../utils/utils.module';
@Component({
  selector: 'nf-when-part',
  templateUrl: './when.component.html',
  styleUrls: ['./when.component.css']
})
export class WhenComponent implements OnInit {
  whenComponentRadioValue = '1'; // When组件radio默认选中
  whenComponentFirstTimeValue = new Date(); // When组件时间选择
  whenComponentCount = 1; // When组件提醒间隔
  whenComponentUnit = 'days'; // When组件提醒周期
  whenComponentRange = 'before'; // When组件提醒范围
  whenComponentSecondTimeValue = new Date(); // When组件时间选择
  whenComponentData: any = {}; // When组件入参数据组装
  unitList = [
    {
      'id': 'days',
      'title': '自然日'
    },
    {
      'id': 'workdays',
      'title': '工作日'
    },
    {
      'id': 'weeks',
      'title': '周'
    },
    {
      'id': 'months',
      'title': '月'
    }
  ];
  rangeList = [
    {
      'id': 'before',
      'title': '之前'
    },
    {
      'id': 'after',
      'title': '之后'
    }
  ];
  @Input('nfData') set ChangeData(data: any) {
    if (data) {
      if (data.hasOwnProperty('dateTrigger')) {
        if (data.dateTrigger.hasOwnProperty('offset')) {
          this.whenComponentData = data.dateTrigger;
          this.whenComponentRadioValue = '2';
          if (this.whenComponentData.offset.count < 0) {
            this.whenComponentCount = -this.whenComponentData.offset.count;
            this.whenComponentRange = 'before';
            this.whenComponentUnit = this.whenComponentData.offset.unit;
            this.whenComponentSecondTimeValue =
              new Date(this.utilsModule.formatDateByGeneral(new Date()) + ' ' + this.whenComponentData.time);
          } else {
            this.whenComponentCount = this.whenComponentData.offset.count;
            this.whenComponentRange = 'after';
            this.whenComponentUnit = this.whenComponentData.offset.unit;
            this.whenComponentSecondTimeValue =
              new Date(this.utilsModule.formatDateByGeneral(new Date()) + ' ' + this.whenComponentData.time);
          }
        } else {
          this.whenComponentData = data.dateTrigger;
          this.whenComponentRadioValue = '1';
          this.whenComponentFirstTimeValue =
            new Date(this.utilsModule.formatDateByGeneral(new Date()) + ' ' + this.whenComponentData.time);
        }
      } else {
        this.whenComponentHandleEdit(data);
      }
    }
  }
  @Output() nfDataChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() closePop: EventEmitter<any> = new EventEmitter<any>();
  constructor(
    private utilsModule: UtilsModule
  ) { }
  ngOnInit() {
  }
  whenComponentOnSubmit() {
    if (this.whenComponentRadioValue === '1') {
      this.whenComponentData['dateTrigger'] = {
        'time': this.utilsModule.formatTimeByGeneral(this.whenComponentFirstTimeValue),
        'description': this.utilsModule.formatTimeByGeneral(this.whenComponentFirstTimeValue)
      };
    } else if (this.whenComponentRadioValue === '2') {
      let txt = '';
      this.unitList.forEach((item, index) => {
        if (item.id === this.whenComponentUnit) {
          txt = item.title;
        }
      });
      this.whenComponentData['dateTrigger'] = {
        'offset': {
          'count': this.whenComponentRange === 'before' ? '-' + this.whenComponentCount : this.whenComponentCount,
          'unit': this.whenComponentUnit
        },
        'time': this.utilsModule.formatTimeByGeneral(this.whenComponentSecondTimeValue),
        'description': this.whenComponentCount + ((this.whenComponentUnit === 'days' || this.whenComponentUnit === 'workdays')? '个':'')
          + txt +
          (this.whenComponentRange === 'before' ? '之前' : '之后') + '的' +
          this.utilsModule.formatTimeByGeneral(this.whenComponentSecondTimeValue)
      };
    }
    this.nfDataChange.emit(this.whenComponentData);
    this.closePop.emit();
  }
  // 处理回填
  whenComponentHandleEdit(data) {
    if (data.hasOwnProperty('offset')) {
      this.whenComponentData = data;
      this.whenComponentRadioValue = '2';
      if (this.whenComponentData.offset.count < 0) {
        this.whenComponentCount = -this.whenComponentData.offset.count;
        this.whenComponentRange = 'before';
        this.whenComponentUnit = this.whenComponentData.offset.unit;
        this.whenComponentSecondTimeValue =
          new Date(this.utilsModule.formatDateByGeneral(new Date()) + ' ' + this.whenComponentData.time);
      } else {
        this.whenComponentCount = this.whenComponentData.offset.count;
        this.whenComponentRange = 'after';
        this.whenComponentUnit = this.whenComponentData.offset.unit;
        this.whenComponentSecondTimeValue =
          new Date(this.utilsModule.formatDateByGeneral(new Date()) + ' ' + this.whenComponentData.time);
      }
    } else {
      this.whenComponentData = data;
      this.whenComponentRadioValue = '1';
      this.whenComponentFirstTimeValue =
        new Date(this.utilsModule.formatDateByGeneral(new Date()) + ' ' + this.whenComponentData.time);
    }
  }
}
